import { css } from "@mds/core";

export const alertCSS = css`
  /* 	###################################################################### */
  /**	
   * Component tokens
	 * Use the design tokens to set these component tokens.
	 */
  :host {
    --text-color: var(--mds-color-text-default);
    --icon-glyph: var(--mds-icon-glyphs-base-check-circle);
    --icon-color: var(--mds-color-feedback-success);
  }

  /* 	###################################################################### */
  /**
   * Textarea host rules
	 * This is the main rule set.
	 */
  :host {
  }

  .mds-alert {
    position: relative;
    display: none;
    max-width: 580px;
    padding: var(--mds-spacing-5);
    padding-left: calc(var(--mds-spacing-5) + var(--mds-icon-size-l) + 1rem);
    border: none;
    margin: 0 auto;
    border-radius: var(--mds-line-border-base-radius);
  }

  .mds-alert[data-open], .mds-alert[open] {
    display: block;
  }

  .mds-alert.success {
    --icon-glyph: var(--mds-icon-glyphs-base-alert-success);
    --icon-color: var(--mds-color-feedback-success);
    background-color: var(--mds-color-feedback-success-background);
  }

  .mds-alert.info {
    --icon-glyph: var(--mds-icon-glyphs-base-alert-info);
    --icon-color: var(--mds-color-feedback-informational);
    background-color: var(--mds-color-feedback-informational-background);
  }
  
  .mds-alert.warning {
    --icon-glyph: var(--mds-icon-glyphs-base-alert-warning);
    --icon-color: var(--mds-color-feedback-warning);
    background-color: var(--mds-color-feedback-warning-background);
  }
  
  .mds-alert.error {
    --icon-glyph: var(--mds-icon-glyphs-base-alert-error);
    --icon-color: var(--mds-color-feedback-error);
    background-color: var(--mds-color-feedback-error-background);
  }

  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: var(--mds-spacing-unit-block);
  }

  .title {
    position: relative;
    margin: 0;
    color: var(--text-color);
  }

  /* Icon background */
  .title::before {
    content: '';
    position: absolute;
    top: calc(-2px + 0.25rem);
    left: calc(-2.5rem + 0.25rem);
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    background-color: var(--mds-color-background-light);
  }
  .mds-alert.warning .title::before {
    left: calc(-2.5rem + 0.75rem);
    width: 0.25rem;
    border-radius: unset;
  }

  /* Icon */
  .title::after {
    content: var(--icon-glyph);
    position: absolute;
    top: -2px;
    left: -2.5rem;
    font-family: var(--mds-icon-font-base-family);
		font-weight: normal;
    font-size: var(--mds-icon-size-l);
		color: var(--icon-color);
		line-height: 1;
  }

  .message {
    color: var(--text-color);
  }
`;
